import React from "react";
import LandingPage from "../../components/additionalprofessional/LandingPage";
export default function AdditionalProfLandingPage() {
  return (
    <>
      <LandingPage />      
    </>
  );
}
